// @core/api/endpoints/booking/create_booking.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingResponse,
  CreateBookingRequest,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Create booking
 * Creates a standalone booking for a bookable resource. If the type requires approval, status is PENDING_APPROVAL; otherwise CONFIRMED immediately.
 */
export async function CreateBooking(
  data: CreateBookingRequest,
  options?: RequestOptions
): Promise<BookingResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/bookings`;
  const requestOptions = options;
  return client.post<BookingResponse>(requestPath, data, requestOptions);
}
